import { IIPENNotaryProfile } from '../../types/Notary';
import { calcDaysUntilExpiry } from './helpers';

export enum Status {
  Pending,
  Active,
  Inactive,
  CommissionExpired,
}

export enum StatusColors {
  Active = 'success.main',
  Pending = 'secondary.main',
  Expired = 'error.main',
  ExpiringSoon = 'warning.main',
  Inactive = 'action.disabled',
}

export const statusText = (notaryData: IIPENNotaryProfile | null) => {
  const daysUntilExpiration = calcDaysUntilExpiry(
    notaryData?.CommissionExpirationDate
  );

  switch (notaryData?.Status) {
    case Status.Pending:
      return 'Pending';
    case Status.Inactive:
      return 'Inactive';
    case Status.CommissionExpired:
      return 'Commission Expired';
    case Status.Active:
      if (
        daysUntilExpiration &&
        daysUntilExpiration <= 30 &&
        daysUntilExpiration > 0
      ) {
        return 'Commission Expiring Soon';
      } else {
        return 'Active';
      }
    default:
      return 'Inactive';
  }
};

export const statusColor = (notaryData: IIPENNotaryProfile | null) => {
  const daysUntilExpiration = calcDaysUntilExpiry(
    notaryData?.CommissionExpirationDate
  );

  switch (notaryData?.Status) {
    case Status.Pending:
      return StatusColors.Pending;
    case Status.Active:
      if (
        daysUntilExpiration &&
        daysUntilExpiration <= 30 &&
        daysUntilExpiration > 0
      ) {
        return StatusColors.ExpiringSoon;
      } else {
        return StatusColors.Active;
      }
    case Status.Inactive:
      return StatusColors.Inactive;
    case Status.CommissionExpired:
      return StatusColors.Expired;
    default:
      return StatusColors.Inactive;
  }
};
